import { CaixaPostalService } from 'src/app/services/caixa-postal.service';
import { FilesDraftService } from 'src/app/services/files-draft.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import * as FileSaver from 'file-saver';
import Swal from 'sweetalert2';
import { RespostaComunicado } from '../../common/interface/respostaComunicado';
import * as dayjs from "dayjs";
import { ModoEscuroService } from 'src/app/services/modoEscuro.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-caixa-postal-comunicado',
  templateUrl: './caixa-postal-comunicado.component.html',
  styleUrls: ['./caixa-postal-comunicado.component.scss']
})
export class CaixaPostalComunicadoComponent implements OnInit {

  comunicado: any;
  idComunicado: any;
  comunicados: any;
  seqProcurador: number;
  loading: boolean = false;
  dadosUsuario: any;
  objUsuario: any;
  anexos: any;
  temAnexo: boolean;
  anexosTratados: any;
  pathArquivo: Object = {};
  arquivoConvertido: any;
  responder: boolean = false;
  respostaComunicado: string = '';
  permiteResposta: boolean;
  dataAtual: Date = new Date();
  file: File;
  files: any = [];
  fileName: string;
  base64File: any = [];
  salvandoRascunho: boolean = false;
  arquivosDraft: Map<string, string> = new Map(); // Map<fileName, url>
  arquivosSalvando: Set<string> = new Set(); // Set<fileName> - arquivos que estão sendo salvos
  modalNomearResponsavel: boolean = false;
  exibirCamposNomear: boolean = false;
  cpfNomear: string = '';
  nomeNomear: string = '';
  listaNomeacoes: Array<any> = [];
  seqCadastroNomeacao: string = '';
  existeNomeado: boolean = false;
  modoEscuro: boolean = false;
  mensagem: any;
  historico: any;
  modalHistorico: boolean = false;
  src: any;
  botaoDesabilitado: boolean = false;
  tipoGedOptions = [
    {
      nome: 'Cópia do documento da OAB',
      codigo: '10'
    },
    {
      nome: 'Procuração digitalizada',
      codigo: '0'
    }
  ];
  selectedTipoGed: { nome: string; codigo: string } | null = null;
  numeroDocumento = '';
  selectedFile: File | null = null;
  selectedFileName = '';
  selectedFileBase64 = '';
  numeroDocumentoTouched = false;

  constructor(
    private sanitizer: DomSanitizer,
    private caixaPostalService: CaixaPostalService,
    private filesDraftService: FilesDraftService,
    private route: ActivatedRoute,
    private router: Router,
    private modoEscuroService: ModoEscuroService
  ) { }

  ngOnInit(): void {
    this.dadosUsuario = localStorage.getItem('contribuinteEmUso');
    this.objUsuario = JSON.parse(this.dadosUsuario);
    this.idComunicado = this.route.snapshot.paramMap.get('comunicado');
    this.seqProcurador = this.objUsuario.seqProcuracao ? this.objUsuario.seqProcuracao : 0;
    this.loading = true;
    this.caixaPostalService.getComunicado(this.objUsuario.codigo, this.idComunicado).subscribe(
      res => {
        this.comunicados = res;
        if (this.comunicados.length > 0) {
          const comunicadoAtual = this.comunicados[0];
          this.botaoDesabilitado = comunicadoAtual.cpfCnpj !== this.objUsuario.cadastro.cpfCnpj;

          for (let i = 0; i < this.comunicados.length; i++) {
            this.comunicados[i].txtMensagem = this.sanitizer.bypassSecurityTrustHtml(this.comunicados[i].txtMensagem);
          }

          if(comunicadoAtual.tipoComunicado.numPopup === true){
            Swal.fire({
              text: 'Por favor, confirme que você está ciente desta mensagem.',
              icon: 'info',
              confirmButtonText: 'Confirmar',
              allowOutsideClick: false,
              allowEscapeKey: false
            });
          }
        }
      },
      err => {
        Swal.fire({
          icon: 'error',
          text: 'Ops! Ocorreu um erro ao carregar o comunicado.'
        })
        this.router.navigate(['/caixa-postal']);
      },
      () => {
        this.loading = false;
        let datPrazoResposta = dayjs(this.comunicados[0].datPrazoResposta);
        datPrazoResposta = datPrazoResposta.add(23, 'hour');
        datPrazoResposta = datPrazoResposta.add(59, 'minute');
        datPrazoResposta < dayjs(this.dataAtual) ? this.permiteResposta = false : this.permiteResposta = true;
        this.caixaPostalService.gerarLeitura(this.comunicados[0].seqCaixaPostal, this.objUsuario.cadastro.codigo, this.seqProcurador).subscribe((res) => {
          if (res !== null && res !== "") {
            Swal.fire({
              icon: 'info',
              text: res
            });
          }
        });
      }
    )

    this.modoEscuroService.modoEscuro$.subscribe(modo => {
      this.modoEscuro = modo;
    });
  }

  converterBase64(base64: any) {
    var binaryString = atob(base64);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    this.arquivoConvertido = bytes.buffer;
  }

  permitirRespostaToggle() {
    if (this.responder == false) {
      this.responder = true;
    } 

    const dataPrazo = dayjs(this.comunicados[0].datPrazoResposta);

    if(dataPrazo.isBefore(dayjs())) {
      Swal.fire({
        icon: 'info',
        title: 'Prezado(a) Senhor(a)',
        html: `Informamos que este comunicado tinha prazo limite até <b>${dataPrazo.format('DD-MM-YYYY')}</b> para ser respondido. Será permitido o envio de sua resposta, entretanto, ela será classificada como extemporânea. Tal classificação pode resultar na inadmissibilidade da resposta ou em outras consequências negativas, como a perda de direitos ou a imposição de sanções, conforme decisão da SEFAZ`
      });
    }
  }

  fechar(){
    this.respostaComunicado = '';
    this.responder = false;
  }

  downloadAnexo(comunicado) {
    this.loading = true;
    this.pathArquivo = {
      "caminhoUrl": comunicado.dscUriAlfresco
    }
    this.caixaPostalService.getAnexos(this.pathArquivo).subscribe(
      res => {
        this.anexosTratados = res;
      },
      err => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 500) {
            this.loading = false;
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Atenção: arquivos em análise e validação, e isto pode levar alguns minutos. Tente novamente mais tarde.'
            });
          }
        }
      },
      () => {
        this.loading = false;
        this.converterBase64(this.anexosTratados.data.arquivo);
        var blob = new Blob([this.arquivoConvertido], { type: 'application/zip' });
        FileSaver.saveAs(blob, this.anexosTratados.data.nomeArquivo);
      }
    )
  }

  responderComunicado() {
    this.loading = true;

    const isNomeacao = this.comunicados[0].isNomeacao;
    const seqContribuinte = isNomeacao ? this.comunicados[0].seqContribuinte : this.objUsuario.codigo;
    const seqProcurador = isNomeacao ? this.comunicados[0].nomeadoCaixaPostal?.seqProcurador : (this.seqProcurador ? this.seqProcurador : null);

    let obj: RespostaComunicado = {
      fkSeqCaixaPostal: this.comunicados[0].seqCaixaPostal,
      datPrazoResposta: this.comunicados[0].datPrazoResposta ? dayjs(this.comunicados[0].datPrazoResposta).format('YYYY-MM-DD') : null,
      numOrigem: this.comunicados[0].numOrigem,
      seqContribuinte: seqContribuinte,
      seqCadastro: this.objUsuario.cadastro.codigo,
      seqTipoComunicado: this.comunicados[0].tipoComunicado.seqTipoComunicado,
      dscAssunto: this.comunicados[0].dscAssunto,
      txtMensagem: this.respostaComunicado,
      temAnexo: false,
      seqProcurador: seqProcurador,
      arquivosDrafts: []
    };
    if (this.files.length > 0) {
      obj.temAnexo = true;
      this.uploadArquivosParaMinio(obj);
    } else {
      obj.temAnexo = false;
      this.chamadaRespostaComunicado(obj)
    }
  }

  uploadArquivosParaMinio(obj: RespostaComunicado) {
    // Verifica se todos os arquivos já foram salvos como rascunho
    const arquivosSemDraft = this.files.filter(file => !this.arquivosDraft.has(file.name));
    
    if (arquivosSemDraft.length > 0) {
      // Se houver arquivos sem draft, salva primeiro
      const uploadPromises: Promise<any>[] = [];
      
      arquivosSemDraft.forEach(file => {
        const promise = new Promise((resolve, reject) => {
          this.filesDraftService.uploadDraft(file).subscribe(
            (url: string) => {
              this.arquivosDraft.set(file.name, url);
              resolve(url);
            },
            (err) => {
              console.error('Erro ao fazer upload do arquivo:', err);
              Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: `Erro ao fazer upload do arquivo ${file.name}. Tente novamente.`
              });
              reject(err);
            }
          );
        });
        
        uploadPromises.push(promise);
      });
      
      Promise.all(uploadPromises).then(() => {
        this.prepararAnexosParaEnvio(obj);
      }).catch(() => {
        this.loading = false;
      });
    } else {
      // Todos os arquivos já têm draft, apenas prepara para envio
      this.prepararAnexosParaEnvio(obj);
    }
  }

  prepararAnexosParaEnvio(obj: RespostaComunicado) {
    // Cria array com os identificadores retornados pela API de upload draft
    this.files.forEach(file => {
      const identificador = this.arquivosDraft.get(file.name);
      if (identificador) {
        obj.arquivosDrafts.push(identificador);
      }
    });
    
    this.chamadaRespostaComunicado(obj);
  }

  chamadaRespostaComunicado(obj) {
    this.caixaPostalService.respostaComunicado(obj).subscribe(
      res => {
        this.loading = false;
      },
      err => {
        this.loading = false;
        Swal.fire({
          icon: 'error',
          title: 'Ops!',
          text: 'Ocorreu um erro ao responder o comunicado! Tente novamente.'
        });
      },
      () => {
        this.loading = false;
        Swal.fire({
          icon: 'success',
          text: 'Comunicação respondida com sucesso!'
        });
        this.router.navigate(['/caixa-postal'])
      }
    )
  }

  onTipoGedChange() {
    this.numeroDocumento = '';
    this.selectedFile = null;
    this.selectedFileName = '';
    this.selectedFileBase64 = '';
  }

  anexo(event: Event) {
    const input = event.target as HTMLInputElement;
    const novos = Array.from(input.files ?? []);
    if (!novos.length) return;

    const MAX = 1024 * 1024 * 1024;
    const key = (f: File) => `${f.name}-${f.size}-${f.lastModified}`;

    const existentes = new Set(this.files.map(key));
    const vistos = new Set<string>();
    const temDuplicado = novos.some(f => {
      const k = key(f);
      if (existentes.has(k) || vistos.has(k)) return true;
      vistos.add(k);
      return false;
    });
    if (temDuplicado) {
      Swal.fire
      ({ 
        icon: 'warning', 
        text: 'Arquivo(s) já anexado(s).' 
      });
      input.value = '';
      return;
      
    }

    const algumMaiorQue100 = novos.some(f => f.size > MAX);
    const totalDepois = [...this.files, ...novos].reduce((s, f) => s + f.size, 0);
    if (algumMaiorQue100 || totalDepois > MAX) {
      Swal.fire
      ({ 
        icon: 'error', 
        text: 'O(s) arquivo(s) deve(m) ter no máximo 1GB.'
      });
      input.value = '';
      return;
    }

    this.files.push(...novos);
    this.file = this.files[0];
    this.fileName = this.file?.name ?? '';
    input.value = '';

    // Salvar rascunho automaticamente para cada arquivo novo
    novos.forEach(file => {
      this.salvarRascunhoArquivo(file);
    });
  }

  salvarRascunhoArquivo(file: File) {
    this.arquivosSalvando.add(file.name);
    this.salvandoRascunho = this.arquivosSalvando.size > 0;
    
    this.filesDraftService.uploadDraft(file).subscribe(
      (url: string) => {
        this.arquivosDraft.set(file.name, url);
        this.arquivosSalvando.delete(file.name);
        this.salvandoRascunho = this.arquivosSalvando.size > 0;
      },
      (err) => {
        console.error('Erro ao salvar rascunho do arquivo:', err);
        this.arquivosSalvando.delete(file.name);
        this.salvandoRascunho = this.arquivosSalvando.size > 0;
        
        Swal.fire({
          icon: 'error',
          title: 'Erro ao salvar rascunho',
          text: `Não foi possível salvar o rascunho do arquivo ${file.name}. Tente novamente.`
        });
        // Remove o arquivo da lista se falhar
        const index = this.files.findIndex(f => f.name === file.name && f.size === file.size);
        if (index !== -1) {
          this.files.splice(index, 1);
        }
      }
    );
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const maxSizeBytes = 20 * 1024 * 1024;
    const file = input.files[0];
    this.selectedFile = file;
    this.selectedFileName = file.name;

    if (file.type !== 'application/pdf') {
      Swal.fire({
        icon: 'warning',
        title: 'Formato inválido',
        text: 'Só é permitido anexar arquivos PDF.',
      });
      this.removeSelectedFile();
      return;
    }

    if (file.size > maxSizeBytes) {
      Swal.fire({
        icon: 'error',
        text: 'O arquivo deve ter no máximo 20MB.',
      });
      this.removeSelectedFile();
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const base64 = (reader.result as string).split(',')[1];
      this.selectedFileBase64 = base64;
    };
    reader.readAsDataURL(file);
  }

  removeSelectedFile() {
    this.selectedFile = null;
    this.selectedFileName = '';
    this.selectedFileBase64 = '';
  }

  canSubmitGed(): boolean {
    return (
      !!this.selectedTipoGed &&
      this.numeroDocumento.trim().length > 0 &&
      !!this.selectedFileBase64
    );
  }

  deletarArquivo(item) {
    const file = this.files[item];
    if (file) {
      this.arquivosDraft.delete(file.name);
      this.arquivosSalvando.delete(file.name);
      this.salvandoRascunho = this.arquivosSalvando.size > 0;
    }
    this.files.splice(item, 1);
  }

  abrirNomearResponsavel() {
    this.modalNomearResponsavel = true;
    this.getNomeacoes();
  }

  fecharNomearResponsavel() {
    this.modalNomearResponsavel = false;
  }

  exibirFormNomear() {
    this.exibirCamposNomear = true;
    this.modalNomearResponsavel = false;
  }

  fecharFormNomear() {
    this.exibirCamposNomear = false;
    this.modalNomearResponsavel = true;
    this.cpfNomear = "";
    this.nomeNomear = "";
    this.selectedTipoGed = null;
    this.numeroDocumento = '';
    this.selectedFile = null;
    this.selectedFileName = '';
    this.selectedFileBase64 = '';
    this.numeroDocumentoTouched = false;
  }

  getNomeacoes() {
    this.loading = true;
    this.listaNomeacoes = [];
    this.caixaPostalService.getNomeacoes(this.idComunicado).subscribe((res: any) => {
      this.listaNomeacoes = res;
      this.seqCadastroNomeacao = res.codigo;

      this.listaNomeacoes.forEach(res => {
        if (res.dataRemocao === null) {
          this.existeNomeado = true;
        }
      });

      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

  validarCpf() {
    if (this.cpfNomear.length == 11) {
      this.loading = true;
      this.caixaPostalService.validarCpf(this.cpfNomear).subscribe((res: any) => {
        this.nomeNomear = res.nome;
        this.seqCadastroNomeacao = res.codigo;
        this.loading = false;
      }, error => {
        Swal.fire({
          icon: 'warning',
          text: 'Usuário não cadastrado. É necessário que o usuário esteja cadastrado e que tenha aderido à adesão do DEC.'
        });
        this.nomeNomear = '';
        this.loading = false;
      });
    } else {
      Swal.fire({
        icon: 'warning',
        text: 'Usuário não cadastrado. É necessário que o usuário esteja cadastrado e que tenha aderido à adesão do DEC.'
      });
    }
  }

  numeros(event) {
    const input = event.target as HTMLInputElement;
    const onlyDigits = input.value.replace(/\D+/g, '');
    input.value = onlyDigits;
    this.numeroDocumento = onlyDigits;
  }

  nomearResponsavel() {
    if (!this.selectedFile) {
      Swal.fire({
        icon: 'warning',
        text: 'Selecione um PDF para enviar.'
      });
      return;
    }
    this.loading = true;
    const dto = {
      seqCadastro: this.seqCadastroNomeacao,
      seqCaixaPostal: this.idComunicado,
      status: 0,
      dtoGed: {
        numeroDocumento: this.numeroDocumento,
        nomeArquivo: this.selectedFileName,
        tipoGed: { codigo: this.selectedTipoGed!.codigo }
      }
    };
    const formData = new FormData();
    formData.append('dto', new Blob([JSON.stringify(dto)], { type: 'application/json' }));
    formData.append('file', this.selectedFile, this.selectedFileName);
    this.caixaPostalService.nomearResponsavel(formData).subscribe({
      next: () => {
        Swal.fire
        ({ 
          icon: 'success', 
          text: 'Nomeação adicionada com sucesso!' 
        })
          .then(() => { this.getNomeacoes(); this.fecharFormNomear(); });
      },
      error: (error) => {
        if (error?.error?.mensagem === 'Deve escolher um arquivo PDF para ser enviad') {
          Swal.fire({
            icon: 'warning',
            text: 'O Arquivo deve ser um PDF válido.'
          });
          this.removeSelectedFile();
        } else if (error?.error?.mensagem === 'Esta caixa postal já tem uma nomeação ativa para este cadastro.') {
          Swal.fire({
            icon: 'warning',
            text: 'Este comunicado já tem uma nomeação ativa para este C.P.F.'
          });
          this.fecharFormNomear();
        } else {
          Swal.fire({
            icon: 'error',
            text: 'Não é possível nomear o próprio usuário. Selecione outro usuário.'
          });
          this.fecharFormNomear();
        }
        this.loading = false;
      }
    });
  }

 removerNomeacao(item) {
    Swal.fire({
      icon: 'question',
      text: 'Confirma remover a nomeação?',
      showCancelButton: true,
      cancelButtonText: 'Não',
      showConfirmButton: true,
      confirmButtonText: 'Sim'
    }).then((result) => {
      if (!result.isConfirmed) return;
      this.loading = true;
      const dto = {
        seqNomeadoCaixaPostal: item.seqNomeadoCaixaPostal,
        seqCadastro: item.seqCadastro,
        seqCaixaPostal: item.seqCaixaPostal,
        status: 1,
        numMotivoRevoga: this.comunicados[0].isNomeacao ? 3 : 2
      };
      const formData = new FormData();
      formData.append('dto', new Blob([JSON.stringify(dto)], { type: 'application/json' }));
      this.caixaPostalService.nomearResponsavel(formData).subscribe({
        next: () => {
          Swal.fire
          ({ 
            icon: 'success', 
            text: 'Nomeação removida com sucesso!' 
          });
          this.getNomeacoes();
        },
        error: () => {
          Swal.fire
          ({ 
            icon: 'error', 
            text: 'Não foi possível remover a nomeação.' 
          });
        }
      }).add(() => this.loading = false);
    });
  }

  baixarHistorico() {
    this.loading = true;
    var blob = new Blob([this.src], { type: 'application/pdf' });
    FileSaver.saveAs(blob, 'historico');
    this.loading = false;
  }

  visualizarHistorico() {
    this.loading = true;
    this.caixaPostalService.getHistorico(this.comunicados[0].seqContribuinte, this.comunicados[0].seqCaixaPostal).subscribe(
      res => {
        this.historico = res.arquivo;
      },
      err => {
        this.loading = false;
        Swal.fire({
          icon: 'error',
          text: 'Ops! Ocorreu uma falha de comunicação. Tente novamente mais tarde.'
        })
      },
      () => {
        var binaryString = atob(this.historico);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        this.src = bytes.buffer;
        this.modalHistorico = true;
        this.pdfCarregado();
      }
    )
  }

  pdfCarregado() {
    this.loading = false;
  }
}
